import { IdentityMatchingRow } from "@/destinations/configs/shared/IdentityMatchingRow/IdentityMatchingRow";
import {
  BaseConfigurationModal,
  BaseConfigurationRow,
} from "./BaseConfiguration";
import { OAuthModal, OAuthRow } from "./OAuth";
import { MicrosoftAdsAudiencesTermsOfServiceRow } from "./MicrosoftAdsAudiencesTermsOfServiceRow";

const BASE_CONFIGURATION = "BASE_CONFIGURATION";
const OAUTH = "OAUTH";
const TERMS = "TERMS";
const IDENTITY_MATCHING = "IDENTITY_MATCHING";

const Rows = {
  [BASE_CONFIGURATION]: BaseConfigurationRow,
  [OAUTH]: OAuthRow,
  [TERMS]: MicrosoftAdsAudiencesTermsOfServiceRow,
  [IDENTITY_MATCHING]: IdentityMatchingRow,
};

const Modals = {
  [BASE_CONFIGURATION]: BaseConfigurationModal,
  [OAUTH]: OAuthModal,
  [TERMS]: null,
};

const RowOrder = [BASE_CONFIGURATION, OAUTH, TERMS, IDENTITY_MATCHING];

const config = {
  Rows,
  RowOrder,
  Modals,
};

export default config;
